<div class="image-preview-wrapper">
  <!-- Reusable Header Component -->
  <app-preview-header
    [fileData]="model"
    [showMetadata]="true"
    [showDownload]="true"
    [showInfo]="meta.length > 0"
    [infoActive]="showInfoPanel"
    (info)="toggleInfo()"
    (download)="downloadMedia($event)"
    (close)="closeDialog()">
  </app-preview-header>

  <!-- Details panel — opens from the header info button. Host supplies the
  rows via dialog data `meta` (warehouse gallery does today; any module
  can later). -->
  @if (showInfoPanel && meta.length) {
    <div class="info-panel">
      <div class="info-panel-head">
        <i class="fas fa-circle-info"></i>
        <span>Details</span>
        <button type="button" class="info-panel-close" (click)="toggleInfo()" aria-label="Close details">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="info-panel-body">
        @for (row of meta; track row) {
          <div class="info-row">
            @if (row.icon) {
              <i class="fas info-row-icon {{ row.icon }}"></i>
            }
            <span class="info-row-label">{{ row.label }}</span>
            <span class="info-row-value">{{ row.value }}</span>
          </div>
        }
      </div>
    </div>
  }

  <!-- Image Controls Toolbar -->
  <div class="image-toolbar">
    <!-- Zoom Controls -->
    <div class="toolbar-group">
      <button class="toolbar-btn" (click)="zoomOut()" [disabled]="zoomLevel <= 50" matTooltip="Zoom Out">
        <i class="fas fa-search-minus"></i>
      </button>
      <span class="zoom-level">{{ zoomLevel }}%</span>
      <button class="toolbar-btn" (click)="zoomIn()" [disabled]="zoomLevel >= 200" matTooltip="Zoom In">
        <i class="fas fa-search-plus"></i>
      </button>
    </div>

    <!-- Rotation Controls -->
    <div class="toolbar-group">
      <button class="toolbar-btn" (click)="rotateLeft()" matTooltip="Rotate Left">
        <i class="fas fa-undo"></i>
      </button>
      <button class="toolbar-btn" (click)="rotateRight()" matTooltip="Rotate Right">
        <i class="fas fa-redo"></i>
      </button>
    </div>

    <!-- Reset -->
    <div class="toolbar-group">
      <button class="toolbar-btn" (click)="resetZoom()" matTooltip="Reset View">
        <i class="fas fa-sync-alt"></i>
      </button>
    </div>
  </div>

  <!-- Image Viewer Body -->
  <div class="image-body">
    <!-- Loading Overlay -->
    @if (isLoading) {
      <app-preview-loading
        [message]="'Loading image...'"
        [overlay]="true">
      </app-preview-loading>
    }

    <!-- Image Container -->
    <div
      class="image-container"
      (mousedown)="onMouseDown($event)"
      [class.dragging]="isDragging">
      <img
        [src]="getMediaUrl()"
        [ngStyle]="getImageStyle()"
        (load)="onImageLoad()"
        (error)="onImageError()"
        alt="{{ model?.original_name || 'Image preview' }}"
        class="image-content"
        draggable="false" />
    </div>

    <!-- Zoom Hint -->
    @if (!isLoading && zoomLevel === 100) {
      <div class="zoom-hint">
        <kbd>Ctrl</kbd> + <i class="fas fa-mouse"></i> to zoom
      </div>
    }
  </div>
</div>
